"use client"
import { useInView } from "react-intersection-observer"

export const useIsSticky = () => {
  const { ref, inView } = useInView({
    rootMargin: "-1px 0px 0px 0px",
    threshold: [1],
    initialInView: true,
  })

  return { ref, isSticky: inView === false }
}
